import React from 'react';
import type { Props } from './types.tsx';
import { context } from './utils.tsx';

export default function DndItemProvider({ scopeIndex, issueId, children }: Props) {
	return <context.Provider value={{ id: { scopeIndex, issueId } }}>{children}</context.Provider>;
}
